<template>

  <div class="container">

    <BreadcrumSection :part1="$t('Accés Obert')"></BreadcrumSection>

    <h1>{{ $t("Accés Obert") }}</h1>

    <MaterialsCommon :init-query="initQuery" router-name="accesObert"></MaterialsCommon>

  </div>

</template>

<script>

import {computed, onMounted} from "vue";
import store from "@/store";
import BreadcrumSection from "@/components/sections/BreadcrumbSection.vue";
import {setMetadata} from "@/composables/metadataFunctions";
import MaterialsCommon from "@/components/MaterialsCommon.vue";
import {useRoute} from "vue-router";
import {useI18n} from "vue-i18n";

export default {
  name: "AccesObertView",
  components: {
    MaterialsCommon,
    BreadcrumSection
  },

  setup(){
    const route = useRoute();
    const { t } = useI18n();

    const initQuery = computed(() => {
      return "activitat_rights:\"Open Access\"";
    });

    onMounted(async () => {
      setMetadata(t('Accés Obert'))
      await store.dispatch('updateSearchSelected', "Accés Obert");
      //await store.dispatch('updateBackgroundImage', require('@/assets/images/sections/banner-open.webp'));
      await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-open.webp') });
    });

    return{
      initQuery
    }
  }
}

</script>

<style scoped>
</style>
